<div class="d-flex justify-content-between align-items-center py-2 px-2 location-wrapper">
  <div class="d-flex align-items-center">
    <h3 class="medium large-text p-0 m-0">
      {{title}}
    </h3>
    <button *ngIf="!isAdding && sharedService.getPermissions('locations_edit') && !isLoading " class="custom-button mx-2" (click)="editLocation()">
      {{isEdit ? 'View' : 'Edit'}}
    </button>
  </div>
  <div class="d-flex align-items-center pr-3">
    <div>
      <button *ngIf="!isLoading && isEdit" class="custom-button-compact p-button" type="submit" (click)="save()">Save</button>
    </div>
    <div class="link-button pl-2">
      <a class="muted7" (click)="cancel()"><img src="./assets/images/close.svg" class="filter-invert" /></a>
    </div>
  </div>
</div>
<div  *ngIf="isLoading" class="bulk-upload-loader">
  <loading></loading>
</div>
  <ng-container *ngIf="!isLoading">
    <div>
      <form [formGroup]="form" (ngSubmit)="save()" class="w-100">
        <simple-control [form]="form" key="id" type="hidden"></simple-control>
        <div class="row m-0">
          <div class="col-6 p-2 location-border">
            <table class="form-table">
              <thead>
                <tr>
                  <th id="location-form-title"></th>
                  <th id="location-form-new-edit"></th>
                </tr>
              </thead>
              <tbody>
                <th id="location-form-header" class="th-display-none"></th>
                <tr>
                  <td class="width-thirty p-2">{{metadata['businessName']}} : </td>
                  <td>
                    <simple-control [label]="metadata['businessName']" [form]="form" key="businessName" type="text"
                      [required]="true" [readonly]="!isEdit"></simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="p-2">{{metadata['address1']}} : </td>
                  <td>
                    <simple-control [label]="metadata['address1']" [form]="form" key="address1" type="text"
                      [required]="true" [readonly]="!isEdit"></simple-control>
                  </td>
                </tr>
              </tbody>
            </table>
            <table class="form-table">
              <thead>
                <tr>
                  <th id="location-form-title"></th>
                  <th id="location-form-new-edit"></th>
                </tr>
              </thead>
              <tbody>
                <th id="location-form-header" class="th-display-none"></th>
                <tr>
                  <td class="width-thirty p-2">{{metadata['city']}} : </td>
                  <td>
                    <simple-control width="100%" [label]="metadata['city']" [form]="form" key="city" type="text" [required]="true"
                      [readonly]="!isEdit"></simple-control>
                  </td>
                  <table class="form-table">
                    <tr>
                      <td colspan="4" class="p-0">
                        <table>
                          <tr>
                            <td colspan="2" class="p-0">
                              <tr>
                                <td class="p-2">{{metadata['stateCode']}}:</td>
                                <td class="p-1">
                                  <simple-control width="100%" [label]="metadata['stateCode']" [form]="form" key="stateCode" type="lookup"
                                    [items]="lookups.stateCode" [required]="true" [readonly]="!isEdit"></simple-control>
                                </td>
                            </td>
                            <td colspan="2" class="p-0">
                              <tr>
                                <td class="zip-space">{{metadata['zip']}}:</td>
                                <td>
                                  <simple-control width="100%" [label]="metadata['zip']" [form]="form" key="zip" type="zip" [required]="true"
                                    [readonly]="!isEdit"></simple-control>
                                </td>
                              </tr>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                </tr>
              </tbody>
            </table>
            <table class="form-table">
              <thead>
                <tr>
                  <th id="location-form-title"></th>
                  <th id="location-form-new-edit"></th>
                </tr>
              </thead>
              <tbody>
                <th id="location-form-header" class="th-display-none"></th>
                <tr>
                  <td class="width-thirty p-2">{{metadata['businessHours']}} : </td>
                  <td>
                    <simple-control [label]="metadata['businessHours']" [form]="form" key="businessHours"
                      type="textarea" [readonly]="!isEdit">
                    </simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="p-2">{{metadata['phone']}} : </td>
                  <td>
                    <simple-control [label]="metadata['phone']" [form]="form" key="phone" type="phone" [required]="true"
                      [readonly]="!isEdit">
                    </simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="p-2">{{metadata['code']}} : </td>
                  <td>
                    <simple-control [label]="metadata['code']" [form]="form" key="code" type="text"
                      [readonly]="!isEdit"></simple-control>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-6 p-2">
            <table class="form-table">
              <tbody>
                <tr>
                  <td class="text-left font-weight-bold"><span class="pickup-delivery-notes">{{metadata['locationPickupNotes']}}</span></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="text-left location-input pr-0">
                    <simple-control width="100%" [label]="metadata['locationPickupNotes']" [form]="form"
                      key="pickupNotes" type="textarea" [readonly]="!isEdit">
                    </simple-control>
                  </td>
                </tr>
                <tr>
                  <td class="text-left font-weight-bold"><span class="pickup-delivery-notes">{{metadata['locationDeliveryNotes']}}</span></td>
                  <td></td>
                </tr>
                <tr>
                  <td class="text-left location-input pr-0">
                    <simple-control width="100%" [label]="metadata['locationDeliveryNotes']" [form]="form"
                      key="deliveryNotes" type="textarea" [readonly]="!isEdit">
                    </simple-control>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row m-0 details-border-top">
          <div class="col-6 px-0 py-2 location-border notes location-view">
            <notes-detail *ngIf="isAdding" [entityName]="'location'" [entityId]="0" [showAdd]="true" [pendingItems]="newNotes" (rowsChange)="newNotes = $event"></notes-detail>
            <notes-detail *ngIf="!isAdding" [entityName]="'location'" [entityId]="model.id" [showAdd]="isEdit" [isViewFromLocation]="!isEdit"></notes-detail>
          </div>
          <div class="col-6 px-0 py-2 location-contact location-view">
            <div>
              <div class="medium medium-text ml-2">Contacts</div>
              <div style="border-bottom: 1px solid #B4B4B4; padding-top:10px; margin-bottom: 10px;"></div>
            </div>
            <contacts-form *ngIf="isEdit" [entityId]="0" entityName="Location" [form]="form" formKey="contacts"></contacts-form>
            <contacts-form *ngIf="!isEdit" [readonly]="true" [entityId]="0" entityName="Location" [form]="form" formKey="contacts"></contacts-form>
          </div>
        </div>
      </form>
    </div>
    <div *ngIf="errors.length > 0 && (isEdit || isAdding)">
      <div *ngFor="let error of errors" class="small-text italic location-error">
        <img src="./assets/images/alert.svg" /> {{error}}
      </div>
    </div>
  </ng-container>
